import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ShiftService } from '../proxy/controlling/controllers/shift.service';
import { DayService } from '@general/proxy/general/controllers/day.service';

FieldBuilder.setNamespace('Controlling');

export const SHIFTWORKINGDAY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('mustInform', 'Entity.ShiftWorkingDay.MustInform')
    .build(),
  FieldBuilder
    .foreignKey('shiftId', 'Entity.Shift', ShiftService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('dayId', 'Entity.ShiftWorkingDay.Day', DayService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const SHIFTWORKINGDAY_CONFIG = {
  entityName: 'ShiftWorkingDay',
  localizationKey: 'Controlling::Entity.ShiftWorkingDay',
  fields: SHIFTWORKINGDAY_FIELDS,
  permission: 'ControllingCalendar.ShiftWorkingDays',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
